import { parse, ParsedUrlQuery } from 'querystring';

import { SearchQueryParams } from '../types/SearchQuery';
import { ALLOWED_PARAMS, ARRAY_PARAMS } from './config';
import filterParams from '../../common/utils/filterParams';
import { PROD_URL } from '../../common/constants';

/**
 * Parses the current url and groups query params as `searchParams` or `nonSearchParams`
 */
const groupSearchParams = (
  url: string,
): {
  searchParams: SearchQueryParams;
  nonSearchParams: ParsedUrlQuery;
} => {
  const { search } = new URL(url, PROD_URL);
  const query = parse(search.slice(1));

  const nonSearchParams = Object.keys(query)
    .filter((key) => !((ALLOWED_PARAMS as string[]).includes(key)));

  return {
    searchParams: filterParams<SearchQueryParams>({
      query,
      allowedParams: ALLOWED_PARAMS,
      arrayParams: ARRAY_PARAMS,
    }),
    nonSearchParams: filterParams({
      query,
      allowedParams: nonSearchParams,
    }),
  };
};

export default groupSearchParams;
